
namespace RioERP.Carts {

    @Serenity.Decorators.registerClass()
    export class CartProductBillingItemsTaxDialog extends Serenity.EntityDialog<CartProductBillingItemsTaxRow, any> {
        protected getFormKey() { return CartProductBillingItemsTaxForm.formKey; }
        protected getIdProperty() { return CartProductBillingItemsTaxRow.idProperty; }
        protected getLocalTextPrefix() { return CartProductBillingItemsTaxRow.localTextPrefix; }
        protected getService() { return CartProductBillingItemsTaxService.baseUrl; }
        protected getDeletePermission() { return CartProductBillingItemsTaxRow.deletePermission; }
        protected getInsertPermission() { return CartProductBillingItemsTaxRow.insertPermission; }
        protected getUpdatePermission() { return CartProductBillingItemsTaxRow.updatePermission; }

        protected form = new CartProductBillingItemsTaxForm(this.idPrefix);

    }
}